<template>
  <div ref="jsoneditor" class="json-editor">
    <div class="editor-options">
      <div v-if="id" class="file-name" @click="handleEvent('edit-description')">
        {{ description ? "编辑描述" : "添加描述" }}
      </div>
      <div class="option save-option" @click="handleEvent('rollback')">
        返回
      </div>
      <div class="option save-option" @click="handleImport">导入</div>
      <div class="option save-option" @click="handleEvent('export')">导出</div>
      <div class="option save-option" @click="handleSave">保存</div>
    </div>
  </div>
</template>

<script>
import JSONEditor from "jsoneditor";

export default {
  name: "JsonEditor",
  props: {
    content: {
      type: Object,
      default: {},
    },
    id: {
      type: String,
      default: "",
    },
    name: {
      type: String,
      default: "",
    },
    description: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      options: {
        modes: ["text", "code", "tree", "form", "view"],
        mode: "code",
      },
      editor: null,
    };
  },
  watch: {
    content(n, o) {
      if (n !== o) {
        this.editor.set(n);
      }
    },
  },
  mounted() {
    this.editor = new JSONEditor(
      this.$refs.jsoneditor,
      this.options,
      this.content
    );
  },
  methods: {
    handleSave() {
      const content = this.editor.get();
      this.$emit("save", content);
    },
    handleEvent(eventType) {
      const content = this.editor.get();
      if (eventType === "export") {
        this.$emit(eventType, content);
      } else {
        this.$emit(eventType);
      }
    },
    handleRename() {
      this.$emit("rename");
    },
    handleImport() {
      this.$emit("import");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./jsoneditor.css";
.json-editor {
  width: 100%;
  height: calc(100vh - 105px);
  position: relative;
  .editor-options {
    position: absolute;
    right: 0px;
    top: 0px;
    font-size: 14px;
    height: 35px;
    line-height: 35px;
    color: #fff;
    z-index: 1;
    cursor: pointer;
    display: flex;
    .file-name {
      margin: 0 8px;
    }
    .option {
      margin: 0 8px;
    }
  }
  .jsoneditor {
    border: none !important;
    .jsoneditor-menu {
      a.jsoneditor-poweredBy {
        display: none !important;
      }
    }
  }
}
</style>
